export default __webpack_public_path__ + "static/media/girar.6e0815c9.svg";